"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BlockedPaymentProviders = void 0;
var _BlockedPaymentProvider = require("./BlockedPaymentProvider");
var _jsxRuntime = require("react/jsx-runtime");
const BlockedPaymentProviders = (param)=>{
    let { paymentProviders } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: paymentProviders.map((pm)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_BlockedPaymentProvider.BlockedPaymentProvider, {
                paymentProviderGroupBlocked: pm
            }, "".concat(pm.displayGroup, "-").concat(pm.name)))
    });
};
exports.BlockedPaymentProviders = BlockedPaymentProviders;
